let authToken = 'perm:YWRtaW4=.NDktMQ==.eMqN2jRWi2DsCQLlqi8q9OyLLZrTQd';
let youtrackApiUrl = 'https://172.24.157.213:8443/api';
let files = [];

export default function () {
    let $ticketSubmit = $('#ticketSubmit');
    if ($ticketSubmit.length) {
        attachSubmitTicketEvent($ticketSubmit);
        attachUploadEvent();
    }

    if ($('[data-view="issues"]')) {
        getCurrentIssues();
    }
}

const createNewIssue = (summary, description) => {
    let data = {
        project: {id: '0-0'}, summary: summary, description: description
    };
    return new Promise((resolve, reject) => {
        $.ajax({
            url       : `${youtrackApiUrl}/issues`, data: JSON.stringify(data), type: 'POST', contentType: 'application/json', beforeSend: function (xhr) {
                xhr.setRequestHeader('Authorization', `Bearer ${authToken}`);
            }, success: function (response) {
                resolve(response);
            }, error  : function (response) {
                reject(response);
            }
        });
    });
};

const attachSubmitTicketEvent = ($ticketSubmit) => {
    $ticketSubmit.click(function (e) {
        e.preventDefault();
        let category = $('#ticketCategory').val(), summary = $('#ticketTitle').val();
        createNewIssue(`${category} - ${summary}`, $('#ticketDescription').val())
            .then(response => addAttachments(response.id))
            .finally(_ => {
                $('form').submit();
            });
    });
};

const addAttachments = (issueNumber) => {
    return new Promise((resolve, reject) => {
        if (files.length > 0) {
            pushAttachments(files, [], 0)
                .then((attachments) => {
                    $.each(attachments, function (index, attachment) {
                        $.ajax({
                            url        : `${youtrackApiUrl}/issues/${issueNumber}/attachments`,
                            data       : JSON.stringify(attachment),
                            type       : 'POST',
                            cache      : false,
                            processData: false,
                            contentType: 'application/json',
                            beforeSend : function (xhr) {
                                xhr.setRequestHeader('Authorization', `Bearer ${authToken}`);
                            },
                            success    : function (response) {
                                // console.debug(response);
                                resolve(response);
                            },
                            error      : function (response) {
                                // console.error(response);
                                reject(response);
                            }
                        });
                    });
                });
        } else {
            resolve('no attachments');
        }
    });
};

const pushAttachments = (files, attachments, index) => new Promise((resolve, reject) => {
    let file = files[index];
    if (file && file.rawFile) {
        convertFileToBase64(file.rawFile).then(result => {
            attachments.push({'name': file.name, 'base64Content': result});
            resolve(attachments);
        }).then(_ => pushAttachments(files, attachments, ++index));
    }
});

const convertFileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

const attachUploadEvent = () => {
    let $upload = $('#files');
    if ($upload.length) {
        let k_upload = $upload.data('kendoUpload');
        if (k_upload) {
            $upload.data('kendoUpload')._events.select = [];
            $upload.data('kendoUpload')._events.select.push(function (e) {
                files = files.concat(e.files);
            });
            $upload.data('kendoUpload')._events.remove = [];
            $upload.data('kendoUpload')._events.remove.push(function (e) {
                $.each(files, function (index, file) {
                    if (file.uid === e.files[0].uid) {
                        files.splice(files.indexOf(file), 1);
                    }
                });
            });
        }
    }
};

const getCurrentIssues = () => {
    $.get(`${youtrackApiUrl}/issues?fields=id,idReadable,summary,comments(text),attachments(name,base64Content)`, function (response) {
        let $issues = $('.issues');
        $issues.html('');
        let issueTemplate = kendo.template('<li aria-expanded="false" class="k-item k-state-default soxexc" role="menuitem"><span class="k-header k-link soxexc__toggle"><div><div><span class="soxexc__project-info">#= idReadable# - #= summary#</span></div></div><span class="k-i-arrow-60-down k-icon k-panelbar-expand"></span></span><div aria-hidden="true" class="k-content" role="region" style="display: none;">#= comments.toString()#</div></li>');
        $.each(response, function (index, issue) {
            $issues.append(issueTemplate(issue));
        });
        $issues.kendoPanelBar({
            expandMode: 'multiple'
        });
    });
};